export type RankingTableSummary = {
  id: string;
  submissionType?: string | null;
};

export type FirmSubmissionTable = {
  ready: boolean;
  rankingTableId: string | undefined;
};

export function orderedFirmTables<T extends RankingTableSummary>(
  rankingTables: T[] | undefined,
  contentTableIds: ReadonlySet<string>,
): T[] {
  const firmTables = (rankingTables ?? []).filter(table => table.submissionType === "firm");
  const withContent = firmTables.filter(table => contentTableIds.has(table.id));
  const withoutContent = firmTables.filter(table => !contentTableIds.has(table.id));
  return [...withContent, ...withoutContent];
}

export function firmSubmissionTable(input: {
  rankingTables: RankingTableSummary[] | undefined;
  contentTableIds: ReadonlySet<string>;
  selectedTableId?: string | null;
}): FirmSubmissionTable {
  if (input.rankingTables === undefined) return { ready: false, rankingTableId: undefined };
  if (input.selectedTableId) return { ready: true, rankingTableId: input.selectedTableId };
  const [defaultTable] = orderedFirmTables(input.rankingTables, input.contentTableIds);
  return { ready: true, rankingTableId: defaultTable?.id };
}
